import React from 'react';
import '../styles/FinishLevel.css';
import { renderHTML } from '../functions';

function FinishLevel(props) {
    const title = props.title;
    const description = props.description;
    const image = props.image;
    const openConditionImageModal = props.openConditionImageModal;
    const index = props.index;
    const selected = props.selected;
    const selectConditionLevel = props.selectConditionLevel;
    
    return (
        <div 
            className={"finish-level-outer-container bg-colour-white cursor-pointer " + (selected === true ? "finish-level-selected" : "")}
            onClick={() => selectConditionLevel(index)}
        >
            <div className="finish-level-inner-container">
                <div className="finish-level-image-container">
                    <img 
                        src={image} 
                        className="finish-level-image cursor-pointer"
                        alt="finish level"
                        onClick={(e) => {
                            e.stopPropagation(); // prevents bubbling up to the outer div
                            openConditionImageModal(index);
                        }}
                    />
                </div>
                <div className="finish-level-text-container">
                    <h2 className="body-bold colour-primary">
                        {title}
                    </h2>
                    <div className="body-regular colour-primary"
                        dangerouslySetInnerHTML={{ __html: renderHTML(description, [], { clickable: false }) }}
                    />
                </div>
            </div>
        </div>
    )
};

export default FinishLevel;